export default "__VITE_ASSET__729cdfff__"